import { useClientSettings } from "@hooks/useClientSettings";

type LogoProps = {
  icon?: boolean;
};

export const Logo = ({ icon }: LogoProps) => {
  const client = useClientSettings();
  const url = icon ? client.assets.favicon : client.assets.logo;

  return (
    <img style={{ maxWidth: "100%", maxHeight: "100%" }} src={url} alt="Logo" />
  );
};
